<div class="d-flex align-items-center justify-content-between py-3">
  <div class="d-flex align-items-center">
    <ngb-pagination class="d-inline-block" [collectionSize]="collectionSize" [(page)]="page"
                    (pageChange)="onPageChange($event)" [pageSize]="maxSize" [maxSize]="displayedPages" [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="boundaryLinks">
      <ng-template ngbPaginationFirst>
        <button type="button" class="btn btn-default btn-sm">
          &lt;&lt;
        </button>
      </ng-template>
      <ng-template ngbPaginationPrevious>
        <button type="button" class="btn btn-default btn-sm">
          &lt;
        </button>
      </ng-template>
      <ng-template ngbPaginationNumber let-p>
        <button type="button" class="btn btn-sm" [ngClass]="{'btn-primary':p === page}">
          {{p}}
        </button>
      </ng-template>
      <ng-template ngbPaginationNext>
        <button type="button" class="btn btn-default btn-sm">
          &gt;
        </button>
      </ng-template>
      <ng-template ngbPaginationLast>
        <button type="button" class="btn btn-default btn-sm">
          &gt;&gt;
        </button>
      </ng-template>
    </ngb-pagination>
    <div class="d-none d-sm-inline-flex align-items-center mt-lg-0">
      <input *ngIf="showGotoPage" class="form-control mx-sm-2"
             style="width: 4.5rem;" type="number"
             [ngModel]="page" (ngModelChange)="gotoDebounced($event)" (keyup.enter)="goToPage()" (mouseup)="goToPage()"
             min="1"
             [max]="Math.ceil(this.collectionSize/this.maxSize)">
      <span class="text-muted" *ngIf="collectionSize && maxSize && showPageCount">
          {{ stringTransformation.transformNumber(Math.ceil(collectionSize / maxSize)) }}&nbsp;{{ Math.ceil(collectionSize / maxSize) === 1 ? ('lang.globals.totalPage' | translate) : ('lang.globals.totalPages' | translate) }}
      </span>
    </div>
  </div>

  <div class="pagination__options d-none d-sm-flex align-items-center" *ngIf="showPageSize">
    <span class="mr-2 text-muted"><ng-content></ng-content></span>
    <div ngbDropdown container="body" class="d-inline-block" placement="top-right" [(open)]="dropdownOpen">
      <button ngbDropdownToggle type="button" class="btn-default btn btn-sm align-items-center">{{maxSize}}
        <sb-icon *ngIf="dropdownOpen" class="dropdownIndicator" icon="chevronUp"></sb-icon>
        <sb-icon *ngIf="!dropdownOpen" class="dropdownIndicator" icon="chevronDown"></sb-icon>
      </button>
      <div ngbDropdownMenu>
        <ul class="dropdown pagination__option_dropdown">
          <li ngbDropdownItem *ngFor="let size of sizes" class="item" (click)="setPageSize(size)"
              [ngClass]="size === maxSize ? 'active' : ''">
            {{size}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
